module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsShow),
      expression: "tipsShow"
    }],
    attrs: {
      "id": "tips"
    }
  }, [_c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("./images/jt.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb"
  }, [_c('img', {
    attrs: {
      "src": require("./images/1.png")
    }
  }), _vm._v(" 点击右上角的 •••")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb"
  }, [_c('img', {
    attrs: {
      "src": require("./images/2.png")
    }
  }), _vm._v(" 选择“在浏览器中打开”")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423c0724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/openAccount/download.vue
// module id = 883
// module chunks = 2